import React, {useEffect, useState, useRef} from 'react';
import { Route, Switch} from 'react-router-dom';
import Layout from './components/Layout';
import Home from './components/Home';
import Pending from './components/Pending';
import RequestSignature from './components/Request';
import Signed from './components/Signed';
import Profile from './components/Profile';
import Login from './components/Login';
import Logout from './components/Logout';
import IframeRoute from './components/IframeRoute';
import { Cookies } from 'react-cookie';
import i18next from 'i18next';

import { useTranslation } from 'react-i18next'
import { Button, Modal } from 'react-bootstrap';

import axios from 'axios';
const constants = require('./components/constants');
const cookies = new Cookies();

const App = props  => {
  const [menuRefresh, setMenuRefresh] = useState(false);
  const [sessionExpired, setSessionExpired] = useState(false);
  const sessionExpiredLogout = useRef(false);
  const { t } = useTranslation();
 
  useEffect(() => {
    function eventMessageHandler(event) {
      console.log("CLOSE LOGIN-IFRAME MESSAGE RECEIVED");
      let frameToRemove = document.getElementById("Iframe");
      if (frameToRemove) {
        frameToRemove.parentNode.removeChild(frameToRemove);
        document.body.style.overflow = "inherit";
        //window.top.location.reload();
        var targetPage = sessionStorage.getItem('targetPage');
        switch(targetPage) {
          case constants.SERVER_CONTEXT_PATH+"/":
            document.getElementById("nav-item-home").click();
            updateMenu();
            break;
          case constants.SERVER_CONTEXT_PATH+"/pending":
            updateMenu();
            document.getElementById("nav-item-pending").click();
            window.top.location.reload();
            break;
          default:
            console.log("unsupported targetPage", targetPage);
        }
      }
    }
    console.log("App useEffect");
      console.log("IFRAME msg handler added");
      window.addEventListener("message", eventMessageHandler);      
    return function cleanup() {
      console.log("IFRAME msg handler removed");
      window.removeEventListener("message", eventMessageHandler);
    }
  }, [sessionExpired]);

  useEffect(() => {
    console.log("App useEffect language");
    var language = cookies.get("language");
    if (language !== undefined && language !== i18next.language) {
      i18next.changeLanguage(language);
    }
  }, []);

  const updateMenu = () => {
    setMenuRefresh(menuRefresh => !menuRefresh);
  }

  const parentEventHandler = (event) =>{
    switch(event) {
      case "UPDATE_MENU":
        console.log("parentEventHandler: Update menu");
          updateMenu();
        break;
      case "SESSION_EXPIRED":
        var sessionToken = cookies.get("sessionToken");
        if(sessionToken !== undefined) {
          console.log("parentEventHandler: Session expired");
          cookies.remove('sessionToken', {path:"/"});
          sessionStorage.setItem('targetPage', constants.SERVER_CONTEXT_PATH+'/login');
          setSessionExpired(true);
          sessionExpiredLogout.current = true;
        }
        break;
      default:
    }
  }

  const updateLanguage = (language) => {
    var languageCookie = cookies.get("language");
    if (languageCookie !== language) {
      cookies.set("language", language);
    }
    if (language !== i18next.language) {
      i18next.changeLanguage(language);
      axios.post(constants.SERVER_URL+'/api/setuserdata', {defaultLang:language})
      .then(resp => console.log("Language set", language))
      .catch(err => console.log("Language set Error", err));
    }
  }

  const modalOnHide = () => {
    setSessionExpired(false);
    updateMenu();
  }

  const showSessionExpiredModal = (props) => {
      setTimeout(() => document.getElementById("expired-modal-button-ok").click(), 3000);
      return (
        <Modal show={sessionExpired} backdrop="static" id={"SessionExpiredModal"} onHide = {modalOnHide}>
        <Modal.Header closeButton>
            <Modal.Title>{t("Session Expired")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{t("Session Expired")}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button id="expired-modal-button-ok" onClick={modalOnHide}>{t("Ok")}</Button>
        </Modal.Footer>
      </Modal>
    )
  }
 

  const getRenderMethod = (defaultComponent, parentEventHandler) => {
    var sessionToken = cookies.get('sessionToken');
  //  console.log("getRenderMethod defaultComponent sessionToken",defaultComponent, sessionToken);
    var Component;
    if(sessionToken !== undefined) {
      // session exists -> pass thru
      Component = defaultComponent;
    } else {
      // no session -> login
      Component = Login;
    }
    var method = (props) => (
      <Component {...props} parentEventCb={parentEventHandler} />
    )
    return method;
  }

  /*
  const getRenderMethodLoggedIn = (Component, parentEventHandler) => {
    // There should be a session exist -> "Firefox 68.8.0esr (64-bit)" and redirect fix
    var method = (props) => (
      <Component {...props} parentEventCb={parentEventHandler} />
    )
    return method;
  }
  */

  const doRender = () => {
    if(sessionExpired) {
      return showSessionExpiredModal();
    } else if(sessionExpiredLogout.current) {
      sessionExpiredLogout.current = false;
      return <Logout/>;
     }
    else {
      return (
        <Layout menuRefresh={menuRefresh} parentEventCb={parentEventHandler} updateLanguageCb={updateLanguage}>
          <Switch>
            <Route exact path={constants.SERVER_CONTEXT_PATH+'/'} render={getRenderMethod(Home, parentEventHandler)} />
            <Route exact path={constants.SERVER_CONTEXT_PATH+'/home'} render={getRenderMethod(Home, parentEventHandler)} />
            <Route path={constants.SERVER_CONTEXT_PATH+'/pending'} render={getRenderMethod(Pending, parentEventHandler)}/>
            <Route path={constants.SERVER_CONTEXT_PATH+'/request'} render={getRenderMethod(RequestSignature, parentEventHandler)} />
            <Route path={constants.SERVER_CONTEXT_PATH+'/signed'} render={getRenderMethod(Signed, parentEventHandler)} />
            <Route path={constants.SERVER_CONTEXT_PATH+'/profile'} render={getRenderMethod(Profile, parentEventHandler)} />
            <Route path={constants.SERVER_CONTEXT_PATH+'/login'} render = {getRenderMethod(Login, parentEventHandler)} />
            <Route path={constants.SERVER_CONTEXT_PATH+'/logout'} render = {getRenderMethod(Logout, parentEventHandler)} />
            <Route render = {getRenderMethod(IframeRoute, parentEventHandler)} />
          </Switch> 
        </Layout>
      );
    }
  }
  return doRender(); 
}
export default (App);

